import React from 'react';

import { Platform, TextStyle } from 'react-native';

import Text from 'components/Text';

import { isWeb } from './responsiveness';

export function applyNewLine(text: string) {
    return text.split(/<br>\n|<br>/).join('\n');
}

export function applyBoldStyle(text: string, style?: TextStyle) {
    const arr = text.split(/<b>|<\/b>/);

    return arr.map((item, i) => (
        <Text key={item} bold={!!(i % 2)} aria-hidden={isWeb}>
            {item}
            <Text
                style={
                    // Fix for custom android fonts lineHeight issue: https://github.com/facebook/react-native/issues/29232
                    Platform.OS === 'android' && style?.lineHeight
                        ? { lineHeight: style.lineHeight + 0.001 }
                        : undefined
                }
                aria-hidden={isWeb}
            />
        </Text>
    ));
}

export function replaceXWithValue(string: string, value: string) {
    return string.replace(/\bX\b/g, `${value}`);
}

// If we have a word like 'Cinemax 2 HD' the alphabetical order will be wrong
// So we need to adjust the string, clip the number to the closest word like this: 'Cinemax2 HD'
export const adjustString = (str: string) => {
    const words = str.split(' ');

    if (words.length > 1 && /\d/.test(words[1])) {
        words[0] += words[1];
        words.splice(1, 1);
    }

    return words.join(' ');
};
